import type { OnboardingTour } from './types';

export const onboardingTours: OnboardingTour[] = [
  {
    id: 'pique-intro',
    name: 'Pique Tour',
    description: 'Learn the basics of Pique',
    steps: [
      {
        id: 'new-note',
        target: '[data-testid="new-page-button-trigger"]',
        title: 'Create a new note.',
        content: "Let's start by creating your first Pique note.",
        placement: 'bottom',
        offset: 20,
        spotlightPadding: 8,
        disableBeacon: true,
        disableScrolling: true,
        requiresInteraction: true,
        actionText: 'Click "New Note" to continue...',
      },
      {
        id: 'record-button',
        target: '[data-testid="recording-button"]',
        title: 'Record & transcribe audio',
        content:
          'Pique can capture your lecture/meeting as it happens through live transcription.',
        placement: 'top',
        offset: 20,
        spotlightPadding: 8,
        disableBeacon: true,
        requiresInteraction: false,
        actionText: 'Click {{nextIcon}} to see another way to use Pique',
      },
      {
        id: 'transcript-upload',
        target: '[data-testid="transcript-upload-button"]',
        title: 'Paste or upload a transcript',
        content: "We'll provide a sample one you can try.",
        placement: 'right-end',
        offset: 20,
        spotlightPadding: 8,
        disableBeacon: true,
        requiresInteraction: true,
        actionText: 'Click the {{addIcon}} button...',
        floaterProps: {
          offset: 6,
        },
      },
      {
        id: 'submit-transcript',
        target: '[data-testid="transcript-submit-button"]',
        title: 'Sample transcript ready to go!',
        content: 'You can use this example to see how Pique works.',
        placement: 'right-end',
        offset: 20,
        spotlightPadding: 8,
        disableBeacon: true,
        requiresInteraction: true,
        actionText: 'Click "Submit" to continue...',
      },
      {
        id: 'create-notes',
        target: '[data-testid="augment-toggle-container"]',
        title: 'Create your notes',
        content:
          'Pique will turn this transcript into a mind map, summary, and action items.',
        placement: 'right-end',
        offset: 20,
        spotlightPadding: 8,
        disableBeacon: true,
        requiresInteraction: true,
        actionText: 'Click {{createNotesIcon}} to start...',
        floaterProps: {
          offset: 12,
        },
      },
    ],
  },
];
